import { useState } from "react";
import Logo from "@/components/feature/Logo";

const socialLinks = [
  { href: "https://www.facebook.com/HurmaSystem", label: "Facebook", icon: "ri-facebook-fill" },
  { href: "https://t.me/hurmainfo", label: "Telegram", icon: "ri-telegram-fill" },
  { href: "https://www.youtube.com/c/HurmaSystem", label: "YouTube", icon: "ri-youtube-fill" },
  { href: "https://www.instagram.com/hurma.system/", label: "Instagram", icon: "ri-instagram-line" },
];

export default function Footer() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);

  return (
    <footer className="border-t border-background-200/60 bg-background-100">
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-10 md:py-20 lg:px-16">
        <div className="mb-14 flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
          <div className="flex max-w-[260px] flex-col gap-4">
            <Logo size="sm" />
            <p className="text-base leading-relaxed text-foreground-600">
              All-in-one HR &amp; Recruitment платформа для сучасних команд.
            </p>
          </div>

          <nav className="flex items-center gap-3">
            {socialLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                aria-label={link.label}
                target="_blank"
                rel="nofollow noreferrer"
                className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-lg bg-foreground-950/[0.06] text-foreground-600 transition-all duration-200 hover:bg-accent-500/20 hover:text-accent-600"
              >
                <i className={`${link.icon} text-sm`}></i>
              </a>
            ))}
          </nav>
        </div>

        <div className="flex flex-col items-center justify-between gap-4 border-t border-background-300/60 pt-8 sm:flex-row">
          <div className="flex items-center gap-4">
            <p className="text-xs text-foreground-600">
              &copy; {new Date().getFullYear()} HURMA. Усі права захищено.
            </p>
            <button
              type="button"
              onClick={() => setIsPrivacyOpen(true)}
              className="whitespace-nowrap cursor-pointer text-xs underline underline-offset-2 text-foreground-600 transition-colors duration-200 hover:text-foreground-950"
            >
              Політика конфіденційності
            </button>
          </div>
        </div>
      </div>

      {isPrivacyOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-foreground-950/50 p-4"
          onClick={() => setIsPrivacyOpen(false)}
        >
          <div
            className="max-h-[85vh] w-full max-w-2xl overflow-y-auto rounded-lg bg-background-50 p-6 md:p-8"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="mb-5 flex items-start justify-between gap-4">
              <h2 className="text-xl font-semibold text-foreground-950">
                Політика конфіденційності
              </h2>
              <button
                type="button"
                onClick={() => setIsPrivacyOpen(false)}
                aria-label="Закрити"
                className="flex h-9 w-9 shrink-0 cursor-pointer items-center justify-center rounded-md text-foreground-600 transition-colors duration-200 hover:bg-background-100 hover:text-foreground-950"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>

            <div className="space-y-4 text-sm leading-relaxed text-foreground-700">
              <p>
                Вебсторінка не здійснює безпосереднього збору персональних даних
                користувачів через форми зворотного зв'язку або іншим чином.
              </p>
              <p>
                Для аналізу відвідуваності та оцінки ефективності роботи цієї
                вебсторінки можуть використовуватися сервіси веб-аналітики
                (зокрема, але не виключно, Google Analytics), які обробляють
                технічну інформацію про використання вебсторінки, серед яких
                можуть бути дані про перегляди сторінок, тип пристрою, браузер,
                операційну систему та іншу інформацію, необхідну для формування
                статистичних звітів і покращення роботи ресурсу.
              </p>
              <p>
                Зазначені технічні дані використовуються агреговано без мети
                прямої ідентифікації конкретної фізичної особи.
              </p>
              <p>
                Вебсторінка може містити посилання, які переспрямовують
                Користувача на інші вебсайти. Обробка та збір персональних даних
                здійснюються відповідно до Політик конфіденційності, розміщених
                на відповідних вебсайтах.
              </p>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
}